import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox } from "antd";
// interface ISelectionCell {}
const SelectionCell = ({ rowData, column, rowIndex }) => {
    const { selectedRowKeys, disabledRowKeys = [], rowKey } = column;
    const isDisabled = disabledRowKeys === null || disabledRowKeys === void 0 ? void 0 : disabledRowKeys.includes(rowData[rowKey]);
    const _handleChange = () => {
        if (isDisabled)
            return;
        const { onChange } = column;
        onChange({ rowData, rowIndex });
    };
    const checked = (selectedRowKeys || []).includes(rowData[rowKey]);
    return (_jsx(Checkbox, { className: `BaseTable__row-cell__selection ${isDisabled ? "disabled" : ""}`, checked: isDisabled ? false : checked, onChange: _handleChange }));
};
export default SelectionCell;
